import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer } from 'mobx-react'

import AddressFormSection from './01-AddressFormSection'
import InformationFormSection from './02-InformationFormSection'
import VisitFormSection from './03-VisitFormSection'
import EquipmentFormSection from './04-EquipmentFormSection'
import MediaFormSection from './05-MediaFormSection'
import OverviewSection from './06-OverviewSection'
import ValidationError from '../../shared/components/ValidationError'

import fieldSpecs from '../fieldSpecs'

@observer
class Form extends Component {

  static defaultProps = {
    current: {
      address: {}
    }
  }

  static propTypes = {
    current: PropTypes.shape({
      address: PropTypes.object.isRequired
    }), //.isRequired,
    geocoder: PropTypes.shape({
      geocodeAddress: PropTypes.func.isRequired
    }),
    goToSection: PropTypes.func,
    hideValidationErrors: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onChangeMultiple: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    steps: PropTypes.array,
    validationObj: PropTypes.object,
  }

  constructor(props: Object) {
    super(props)
    this.state = {
      // eslint-disable-next-line
      formData: {}
    }
  }

  render() {

    const {
      current,
      geocoder,
      hideValidationErrors,
      dirty,
      validationObj,
      readOnly,
      section,
      onChange,
      onChangeMultiple,
      steps,
      goToSection
    } = this.props

    const sectionProps = {
      ...current,
      validationObj,
      readOnly,
      onChange,
      dirtyFields: dirty,
      steps,
      goToSection,
      fieldSpecs
    }

    return (
      <div className="horizontal">
        <div className="vertical v-scrollable">

          <AddressFormSection
            show={section === 'address'}
            {...sectionProps}
            geocoder={geocoder}
            onChangeMultiple={onChangeMultiple}
          />

          <InformationFormSection
            show={section === 'information'}
            {...sectionProps}
          />

          <VisitFormSection
            show={section === 'visit'}
            {...sectionProps}
          />

          <EquipmentFormSection
            show={section === 'equipment'}
            {...sectionProps}
          />

          <MediaFormSection
            show={section === 'media'}
            {...sectionProps}
          />

          <OverviewSection
            show={section === 'overview'}
            {...sectionProps}
          />

        </div>

        <ValidationError
          className="fixed"
          validFields={current.validFields}
          fieldSpecs={fieldSpecs}
          steps={steps}
          goToSection={goToSection}
          readOnly={readOnly || hideValidationErrors}
        />

      </div>
    )
  }
}

export { Form as default }



// WEBPACK FOOTER //
// ./src/museum/components/Form.js